import { api } from '../api';
import getActiveLetter from '../mixins/get-active-letter';
import getActivePage from '../mixins/get-active-page';

Vue.component('hb-listing', {
  template: `
    <div class="listing">
      <!-- placeholder -->
      <div class="listing__inner listing__inner--placeholder">
        <ul class="listing__group">
          <li v-for="entry of entriesPerGroup">
            <span class="listing__entry listing__entry--placeholder"></span>
          </li>
        </ul>
      </div>
    
      <div class="listing__inner listing__inner--real">
        <ul class="listing__group"
            v-for="group of entryGroups"
        >
          <li v-for="entry of group">
            <a class="listing__entry" 
               v-if="entry"
               :href="entry.url"
            >{{ entry.name.length ? entry.name: 'No Name' }}</a>
            
            <span class="listing__entry listing__entry--placeholder"
                  v-else
            ></span>
          </li>
        </ul>
      </div>
      
      <hb-pagination :totalPages="totalPages"></hb-pagination>
    </div>
  `,
  mixins: [
    getActiveLetter,
    getActivePage
  ],
  data: () => ({
    entryGroups: null,
    entryGroupsCount: 3,
    entriesPerGroup: 20,
    totalPages: 0,
  }),
  watch: {
    '$route': function () { this.fetchEntries(); }
  },
  created() {
    this.fetchEntries();
  },
  methods: {
    fetchEntries() {
      api.get({
        symbol: this.getActiveLetter,
        page: this.getActivePage,
      }, data => {
        this.totalPages  = data.totalPages;
        this.entryGroups = this.splitEntriesIntoGroups(data.posts);
        this.fillLackingGroups();
        this.fillLackingEntries();
      });
    },
    splitEntriesIntoGroups(entries) {
      return entries.map((_, i) =>
        i % this.entriesPerGroup === 0
          ? entries.slice(i, i + this.entriesPerGroup)
          : null
      ).filter(e => e);
    },
    fillLackingGroups() {
      if (this.entryGroups.length < this.entryGroupsCount) {
        const vacantPlaces = this.entryGroupsCount - this.entryGroups.length;
        for (let i = 0; i < vacantPlaces; i++) this.entryGroups.push([]);
      }
    },
    fillLackingEntries() {
      const firstGroup = this.entryGroups[0];

      if (firstGroup.length < this.entriesPerGroup) {
        const vacantPlaces = this.entriesPerGroup - firstGroup.length;
        for (let i = 0; i < vacantPlaces; i++) firstGroup.push(null);
      }
    }
  }
});
